import { apiFetch } from '@/lib/api';

export interface AiTaskRow { key: string; label: string; vision: boolean; model: string | null; }
export interface AiTasks { default_model: string | null; tasks: AiTaskRow[]; }

export function getAiTasks(): Promise<AiTasks> {
  return apiFetch<AiTasks>('/ai-tasks');
}
export function updateAiTasks(body: {
  default_model?: string | null;
  bindings?: Record<string, string | null>;
}): Promise<AiTasks> {
  return apiFetch<AiTasks>('/ai-tasks', { method: 'PUT', body: JSON.stringify(body) });
}
